import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import ClaimsOld from '../ClaimsOld';
import { ClaimsContainer, ClaimsNav, Logo, MobileButton, DesktopButton } from './styled';
import ClaimsDashboard from '../ClaimsDashboard';
import useCurrentContract from '../../../hooks/useCurrentContract';

const MemberExperienceClaimsNav = () => (
  <ClaimsNav>
    <Logo />
    <DesktopButton
      variant="success"
      onClick={() => (window.location.href = '/dashboard/nomad-insurance')}
    >
      Back to dashboard
      <FaArrowRight />
    </DesktopButton>
    <MobileButton
      variant="success"
      onClick={() => (window.location.href = '/dashboard/nomad-insurance')}
    >
      Dashboard
      <FaArrowRight />
    </MobileButton>
  </ClaimsNav>
);

const Claims = () => {
  const { swContracts, tmContracts } = useCurrentContract();

  const shouldRenderNewClaims = swContracts?.length || !tmContracts?.length;

  return (
    <>
      <MemberExperienceClaimsNav />
      <ClaimsContainer>
        {shouldRenderNewClaims ? <ClaimsDashboard /> : <ClaimsOld />}
      </ClaimsContainer>
    </>
  );
};

export default Claims;
